<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !radioStatus}"
          @click="radioStatus =! radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioValue.value"
          @change="changeOption"
        >
          {{ radioValue.value }}
        </el-radio>
        <el-input
          v-if="value === 'number' && radioStatus === true"
          v-model.number="num"
          :min="min"
          :max="max"
          type="number"
          class="control__aditional"
          :disabled="!radioStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox
        v-model="radioStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'RadioExtendedNum',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: String,
      default: ''
    },
    numDefault: {
      type: Number,
      default: 80
    },
    hint: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: Function
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.default,
      num: this.numDefault,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false
    }
  },
  emits: ['changeOption'],
  computed: {
    ...mapState(['clearOptions'])
  },
  watch: {
    clearOptions (val) {
      if (val) {
        this.radioStatus = false
      }
    },
    eventClick (val) {
      this.value = this.default
      this.num = this.numDefault
      this.radioStatus = val
    },
    radioStatus (val) {
      if (val == true) {
        this.changeOption()
      }
    }
  },
  methods: {
    changeOption () {
      console.log(this.max)

      const value = this.radioStatus === true && this.value !== 'number'
        ? `${this.value}` : this.radioStatus === true && this.value === 'number' &&
        this.num > 0 ? `${this.num}` : ''

      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>
